export default "__VITE_PUBLIC_ASSET__a9d4ca74__"